<template>
    <div class="kpi-graph-wrapper">
        <div class="kpi-section kpi-header">
            <div class="kpi--name">{{dynamicData.name}}</div>
            <div class="kpi-stops">
                <span>TIEMPO EN PARADA</span>
                <div class="kpi--stops-time">{{ dynamicData.stopsTime }}</div>
            </div>
        </div>
        <div class="kpi-section kpi-body">
            <div class="kpi-body-upper-section-container">
                <div class="kpi-confection-wrapper kpi-label c-flexer">
                    <div class="kpi--confection">{{ dynamicData.confection }}</div>
                </div>
                <div class="kpi-order-wrapper kpi-label c-flexer">
                    <div class="kpi--order">{{ dynamicData.order }}</div>
                </div>
            </div>

            <div class="kpi-oee-graph c-flexer">
                <vue-circle
                    ref="circle"
                    :progress="dynamicData.efficiencyPercentage"
                    :size="160"
                    :reverse="false"
                    line-cap="round"
                    :fill='{ gradient: [`${dynamicData.efficiencyPercentage > dynamicData.target_oee ? "green" : "red"}`] }'
                    empty-fill="rgba(255, 255, 255, 1)"
                    :animation-start-value="0.0"
                    :start-angle="-1.55"
                    insert-mode="append"
                    :thickness="8"
                    :show-percent="true"
                />
            </div>
            <div class="kpi-delayed">
                <span>{{ dynamicData.format }} ATRASADAS</span>
                <div class="kpi--delayed-units">{{ dynamicData.delayedUnits }}</div>
            </div>

        </div>
        <div class="kpi-section kpi-footer">
            <div class="kpi-reference-wrapper kpi-label">
                <div class="kpi--reference">{{ dynamicData.brand }}</div>
            </div>
            <div class="footer-lower-section">
                <div class="kpi-machine-status">
                    <div :class="['kpi--machine-status ', `${dynamicData.equipment_state_class}`]">
                        {{ dynamicData.equipment_state_label }}
                    </div>
                </div>
                <div class="kpi-shift">
                    <div class="kpi--shift">{{ dynamicData.shift }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VueCircle from 'vue2-circle-progress';
export default {
    name: "KPIGraph",
    components:{
        VueCircle,
    },
    props:{
        machineId: Number
    },
    data(){
        return{
            statusColor: '',
            trackingDotWidth:12, // SOLO NUMEROS PARES
            isLoading: true,

        }
    },
    methods:{
        existsProperty(obj, propertyName){
            return obj.hasOwnProperty(propertyName) && obj[propertyName] != null;
        },
        updateVueCircle(){
            setTimeout(() => {
                this.$refs.circle.updateProgress(this.kpiData?.efficiency_percentage ?? 0);
                this.$refs.circle.updateFill({gradient: [`${this.kpiData?.efficiency_percentage >= this.kpiData?.target_oee ? "green" : "red"}`]});
            }, 500);
        }
    },
    computed: {
        ...mapGetters('monitorization',['activeMachineById']),
        dotPos(){
            return Math.min (100, Math.max(0, this.kpiData?.completed_percentage ?? 0));
        },
        kpiData(){
            let activeMachineData = this.activeMachineById(this.machineId);
            return activeMachineData && activeMachineData.hasOwnProperty('machine')? activeMachineData: null;
        },
        dynamicData(){
            this.updateVueCircle();
            return {
                name:           this.kpiData?.machine?.descrip ?? 'Equipo Desconocido',
                order:          this.kpiData?.order_reference?.descrip ?? 'Desconocida',
                brand:          this.kpiData?.reference?.descrip ?? 'Desconocida',
                confection:     this.kpiData?.reference?.primary_confection ?? 'Desconocida',
                format:         this.kpiData?.packaging + 'S' ?? 'UNIDADES',
                shift:          this.kpiData?.shift?.description?? 'Sin Turno',
                delayedUnits:   this.kpiData?.delayed_units?? 'Offline',
                stopsTime:      this.kpiData?.total_stops_time??0 ?? 'Offline',
                efficiencyPercentage: isNaN(parseFloat(this.kpiData?.efficiency_percentage)) ? 0 : parseFloat(this.kpiData?.efficiency_percentage),
                target_oee:     this.kpiData?.target_oee ?? 0,
                equipment_state_class: this.kpiData?.equipment_state_class ?? 'offline',
                equipment_state_label: this.kpiData?.equipment_state_label ?? 'Offline',
            }
        }
    }
}
</script>

<style >

</style>
